import { render, staticRenderFns } from "./VulnerabilityLabel.vue?vue&type=template&id=5748368e&scoped=true"
var script = {}
import style0 from "./VulnerabilityLabel.vue?vue&type=style&index=0&id=5748368e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5748368e",
  null
  
)

export default component.exports